import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const emptyAsync = () => {
    return new BasicAsyncEnumerable(async function* iterable() { });
};
